/**
 * 
 * @see https://developers.google.com/youtube/iframe_api_reference?hl=fr
 */
class Youtube {

	/**
	 * 
	 * @type Array
	 */
	contextElementToInitList = [];

	/**
	 * 
	 * @type Boolean
	 */
	isInit = false;

	/**
	 * 
	 * @type Boolean
	 */
	isReady = false;

	/**
	 * 
	 * @type Array
	 */
	playerList = [];

	/**
	 * 
	 */
	constructor()
	{

	}

	/**
	 * 
	 */
	init()
	{
		if ( true === this.isInit ) return;

		this.onPlayerStateChange = this.onPlayerStateChange.bind( this );

		window.onYouTubeIframeAPIReady = () =>
		{
			this.isReady = true;

			this.contextElementToInitList.forEach( ( contextElement ) =>
			{
				this.maybeInitPlayers( contextElement );
			} );

			this.contextElementToInitList = [];
		};

		const tag = document.createElement( 'script' );
		tag.src = "https://www.youtube.com/iframe_api";
		document.body.appendChild( tag );

		this.isInit = true;
	}

	/**
	 * 
	 */
	maybeInitPlayers( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = document.body;
		}

		const ytElements = contextElement.querySelectorAll( 'div.wmu-youtube-embed' );

		if ( 0 === ytElements.length ) return;

		if ( ! this.isInit )
		{
			this.init();
		}
		
		if ( ! this.isReady )
		{
			this.contextElementToInitList.push( contextElement );
			return;
		}

		ytElements.forEach( ( element ) =>
		{
			const player = new YT.Player( element.getAttribute( 'id' ), {
				videoId: element.getAttribute( 'data-video-id' ),
				events: {
					'onStateChange': this.onPlayerStateChange,
				}
			} );

			this.playerList.push( player );
		} );
	}

	/**
	 * 
	 */
	onPlayerStateChange( event )
	{
		if ( event.data == YT.PlayerState.PLAYING )
		{
			this.playerList.forEach( ( player ) =>
			{
				if ( player.getPlayerState() == YT.PlayerState.PLAYING && event.target != player )
				{
					player.pauseVideo();
				}
			} );
		}
	}
	
}

export default Youtube;